class GlobalSwiper {
  constructor() {
    this.instances = [];
    this.init();
    
    document.addEventListener('shopify:section:load', () => this.init());
    document.addEventListener('shopify:section:unload', (e) => this.destroy(e.target));
  }

  init(container = document) {
    // Find all uninitialized swiper containers that have the global attribute
    const swiperElements = container.querySelectorAll('.swiper[data-swiper-options]:not(.swiper-initialized), [data-swiper-slider]:not(.swiper-initialized)');

    swiperElements.forEach((element) => {
      // Allow opting out of global initialization
      if (element.hasAttribute('data-swiper-ignore')) return;
      
      let options = {};
      
      // Parse custom options
      if (element.hasAttribute('data-swiper-options')) {
        try {
          options = JSON.parse(element.getAttribute('data-swiper-options'));
        } catch (error) {
          console.error('GlobalSwiper: Error parsing swiper options on element', element, error);
        }
      }

      // Handle scoped pagination and navigation relative to the parent section
      const parentSection = element.closest('.shopify-section') || element.parentElement;
      
      const nextElSelector = element.getAttribute('data-swiper-next');
      const prevElSelector = element.getAttribute('data-swiper-prev');
      const paginationSelector = element.getAttribute('data-swiper-pagination');

      const findElement = (selector) => {
        if (!selector) return null;
        return element.querySelector(selector) || 
               element.parentElement.querySelector(selector) || 
               parentSection.querySelector(selector);
      };

      const nextEl = findElement(nextElSelector) || findElement('.swiper-button-next');
      const prevEl = findElement(prevElSelector) || findElement('.swiper-button-prev');
      const paginationEl = findElement(paginationSelector) || findElement('.swiper-pagination');

      // Default options
      const defaultOptions = {
        observer: true,
        observeParents: true,
      };

      if (nextEl && prevEl) {
        defaultOptions.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      if (paginationEl) {
        defaultOptions.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      // Merge defaults with custom options
      const finalOptions = Object.assign({}, defaultOptions, options);
      
      // Deep merge navigation and pagination if defined in both
      if (options.navigation) {
          finalOptions.navigation = Object.assign({}, defaultOptions.navigation, options.navigation);
      }
      if (options.pagination) {
          finalOptions.pagination = Object.assign({}, defaultOptions.pagination, options.pagination);
      }

      // Allow evaluating breakpoint variables if needed
      // Swiper handles breakpoints internally, so we don't need to do anything special

      const swiperInstance = new Swiper(element, finalOptions);
      this.instances.push({ element, instance: swiperInstance });
      
      element.classList.add('swiper-initialized-global');
    });
  }

  destroy(container) {
    const swiperElements = container.querySelectorAll('.swiper-initialized-global');
    swiperElements.forEach((element) => {
      const index = this.instances.findIndex((item) => item.element === element);
      if (index !== -1) {
        this.instances[index].instance.destroy(true, true);
        this.instances.splice(index, 1);
        element.classList.remove('swiper-initialized-global');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.globalSwiper = new GlobalSwiper();
});
